import { mount } from "../utils/dom.js";
import { Gallery } from "../components/gallery/Gallery.js";

export function mountGallery() {
  mount("gallery-mount", Gallery);
}
